import { Theme } from '@mui/material';
import { showConfirmDialogComponent } from '../core/ConfirmDialog';
import { ILegalTransactionFullObject } from '../Interfaces/ILegalTransaction';

export const handleInvoiceReminder = async (
  legalTransaction: ILegalTransactionFullObject,
  theme: Theme
) => {
  const isInProgress = legalTransaction.idLegalTransactionState <= 5;
  const hasAnyInvoiceReminder = legalTransaction.LegalClientArray.some(
    c => c.enableInvoiceReminding
  );

  return isInProgress &&
    legalTransaction.LegalClientArray.length > 0 &&
    !hasAnyInvoiceReminder
    ? await showConfirmDialogComponent(
        'Warnung',
        'Mindestens ein Mandant sollte eine Rechnungserinnerung erhalten. Sind Sie sicher, dass Sie den Vorgang dennoch speichern möchten?',
        'Dennoch speichern',
        'Ändern',
        theme
      )
    : true;
};
